var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-app-type",on:{"click":_vm.goTop}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }